import React from 'react'
import Link from 'gatsby-link'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { GoogleMap, Marker, DirectionsRenderer, withGoogleMap } from "react-google-maps";
import MarkerClusterer from "react-google-maps/lib/addons/MarkerClusterer.js";
const googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.27&libraries=places,geometry&key=AIzaSyAcVx8hCXnGs25IODK1LVhHzPeCeI02QJI"


let lasturl = "";
const doFunShit = (ur = "") => {
	if(ur == lasturl) return false;
	lasturl = ur;
  const sex = confirm(`Oh no! No Moviepass theaters near your house! But no worries we can take you to our favorite one and only Pornhub. Wanna go ;) ?`);
	if (sex === true) {
  		window.location = 'https://www.pornhub.com';	
	} else {
	    document.body.classList.add('doMagic');
	}
}
 const ajx = (ur,c) => {
         	    const xhttp = new XMLHttpRequest();
        		xhttp.onreadystatechange = function() {
        			if (this.readyState == 4 && this.status == 200) {
        				let res = JSON.parse(xhttp.responseText);
        				c(res);   				
        			}else if(this.status == 404){
        				doFunShit(ur);
        			}
        		};
        		xhttp.open("GET", ur, true);
        		xhttp.send();    
 }

const cache = new CellMeasurerCache({
  defaultHeight: 50,
  fixedWidth: true
});    
const WrappedGoogleMap = withGoogleMap(props => (
  <GoogleMap
    defaultZoom={8}
    defaultCenter={{ lat: 40.714859, lng: -74.014968 }}
    {...props}
  />
));

class Header extends React.Component{
  constructor(props){
    super(props)
  }
  render(){
    return (
      <div style={{
        height: '500px',
        color: 'white',
      }} >
        <div style={{
          position: 'absolute',
          left: '0',
          top: '20%',
          right: '0',
          transform: 'skewY(-12deg)',
          zIndex: '-1',
        }}>
          <div style={{
          	backgroundColor: 'rgb(180, 2, 183)',
            background: 'radial-gradient(at 0px 6000px, rgb(180, 2, 183) 0%, rgb(255, 170, 170) 100%)',
            height: '2000px',
            position: 'absolute',
            top: 'auto',
            left: '0',
            right: '0',
            bottom: '-310px',
          }}>
          </div>
        </div>

     {(this.props.logohead) ? 
        <div style={{
          padding: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '50px',
        }}>
          {this.props.logo}

          <div style={{
            marginLeft: '20px',
          }}>
          	<PaperCraft text={this.props.logohead} style={{textAlign: "center"}}/>
          </div> 
        </div> : null }        
        {(this.props.tagline) ? 
        <div style={{
          fontSize: '30px',
          textAlign: 'center',
        }}>
          {this.props.tagline}
        </div> : null }
        <div style={{
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

class Demo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      address: '',
      locationResults: null,
      loading: false,

      destinationIndex: 0,
      directions: null,
      lastLatLng: null,
    }
    this.handleSelect = this.handleSelect.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.renderGeocodeFailure = this.renderGeocodeFailure.bind(this)
    this.renderGeocodeSuccess = this.renderGeocodeSuccess.bind(this)
  }
  componentDidMount(){
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos)=>{
        	const {latitude: lat, longitude: lng} = pos.coords;

        	this.handleRightClick({
				lat, lng,
        		lat: 37.59682400108367,
        		lng: -114.345703125,
        	});
			this.getFromLatLng({ lat, lng, });
        });
     }
     this.setState({ viewHeight: .8 * window.innerHeight })
  }
  handleRightClick = (e = {}) => {
    const DirectionsService = new google.maps.DirectionsService();
    let ilat, ilng;
    if(e.latLng){
    	let { lat, lng } = e.latLng;
    	ilat = lat();
    	ilng = lng();
    }else{
    	let a;
    	if(this.state.lastLatLng){
    		a = this.state.lastLatLng
    	}else{
    		a = e;	
    	}
    	let { lat, lng } = a;
    	ilat = lat;
    	ilng = lng;
    }
	if(ilat) this.setState({ lastLatLng: { lat: ilat, lng: ilng } });
	if(!ilat || !this.state.locationResults) return false;

	const destinationIndex = this.state.destinationIndex  || 0;
	const destination = new google.maps.LatLng(this.state.locationResults[destinationIndex].lat, this.state.locationResults[destinationIndex].lon);

    DirectionsService.route({
      origin: new google.maps.LatLng(ilat, ilng),
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING,
    }, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        this.setState({
          directions: result,
        });
      } else {
        console.error(`error fetching directions ${result}`);
      }
    });
  }
  handleSelect(address) {
    this.setState({
      address,
      loading: true
    })
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
		this.getFromLatLng({ lat, lng });
      })
      .catch((error) => {
      	doFunShit();	
        this.setState({
          loading: false
        })
      })
  }
getFromLatLng = ({lat, lng}) => {
	ajx(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=false`,(res)=>{
	  let postal_code = 10009;
	  res.results.map(o=>{
		o.address_components.map(ox=>{
			if(ox.types[0]=="postal_code")
				postal_code = parseInt(ox.long_name);
		})
	  });
	  this.getFromPostal(postal_code);
	});
}
getFromPostal = (postal_code) => {
	ajx(`https://cdn.rawgit.com/dsslimshaddy/moviepass/655ef885/theaters/${postal_code}.json`,(res)=>{
		this.setState({
			locationResults: res,
				loading: false
		}) 				
		setTimeout(this.handleRightClick,1000);
	});	
}
  handleChange(address) {
    this.setState({
      address,
      locationResults: null,
      destinationIndex: 0,
    })
  }

  renderGeocodeFailure(err) {
    return (
      <div className="alert alert-danger" role="alert">
        <strong>Error!</strong> {err}
      </div>
    )
  }

  renderGeocodeSuccess(lat, lng) {
    return (
      <div className="alert alert-success" role="alert">
        <strong>Success!</strong> Geocoder found latitude and longitude: <strong>{lat}, {lng}</strong>
      </div>
    )
  }
  render() {
    const cssClasses = {
      root: 'form-group',
      input: 'Demo__search-input',
      autocompleteContainer: 'Demo__autocomplete-container',
    }

    const AutocompleteItem = ({ formattedSuggestion }) => (
      <div className="Demo__suggestion-item">
        <i className='fa fa-map-marker Demo__suggestion-icon'/>
        <strong>{formattedSuggestion.mainText}</strong>{' '}
        <small className="text-muted">{formattedSuggestion.secondaryText}</small>
      </div>)

    const inputProps = {
      type: "text",
      value: this.state.address,
      onChange: this.handleChange,
      onBlur: () => {  },
      onFocus: () => {  },
      autoFocus: true,
      placeholder: "Search Places",
      name: 'Demo__input',
      id: "my-input-id",
    }

    let github = (
        <a href="https://github.com/dsslimshaddy/moviepass-react"><img style={{
       	 position: 'absolute',
         top: 0,
         right: 0,
         border: 0,
     }} 
        src="https://camo.githubusercontent.com/365986a132ccd6a44c23a9169022c0b5c890c387/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f7265645f6161303030302e706e67" alt="Fork me on GitHub" data-canonical-src="https://s3.amazonaws.com/github/ribbons/forkme_right_red_aa0000.png" /></a>    
    );
    return (

      <div className='page-wrapper'>
     	{github}
	    <Header
	    	logo={""}
    		logohead={(!this.state.locationResults) ? "Moviepass" : ""}
    		tagline={(!this.state.locationResults) ? 

         <div
         onClick={()=>{
         	this.setState({oneTime : true})
         }}
         >
         {(this.state.oneTime) ? null : 
         	<div
         style={{
    		background: 'rgba(47, 47, 47, 0.5)',
    		padding: '10px',
         }}         	
         	>
	          <h1 className='display-3'><PaperCraft text="" />Hi Redditors  <i className='fa fa-map-marker header'/></h1>
	          <p className='lead'>
	          	This is a upgraded of former <a href="http://mdudetm.com/moviepass/">moviepass</a> location website
	          	<br />
	    		Now you dont need to remember the zip code
	          </p>
	          </div>
	      }
          </div>
    			: ""}
	    >
        <div className='container normalfix'>
          <PlacesAutocomplete
            onSelect={this.handleSelect}
            autocompleteItem={AutocompleteItem}
            onEnterKeyDown={this.handleSelect}
            classNames={cssClasses}
            inputProps={inputProps}
          />
          {this.state.loading ? <div><i className="fa fa-spinner fa-pulse fa-3x fa-fw Demo__spinner" /></div> : null}
          {!this.state.loading && this.state.locationResults ?
          	<div
          	style={{
          		display: 'flex',
          	}}
          	>
          	<div
  			  style={{
  			  	flex: '0 1 auto',
  			  }}          	
          	>
              <List
              className="vlist"
    			width={400}
    			height={this.state.viewHeight || 450}
    			rowCount={this.state.locationResults.length}
			    deferredMeasurementCache={cache}
			    rowHeight={cache.rowHeight}
			    rowRenderer={this.rowRenderer}    			
			    destinationIndex={this.state.destinationIndex}

  			    />
  			</div>
  			 <div
  			  style={{
  			  	flex: '1 1 auto',
  			  }}
  			 >

				  <WrappedGoogleMap
				    googleMapURL={googleMapURL}
			        containerElement={
			          <div style={{ height: `100%` }} />
			        }
			        mapElement={
			          <div style={{ height: `100%` }} />
			        }
			        defaultCenter={{
			         lat: parseFloat(this.state.locationResults[0].lat),
			         lng: parseFloat(this.state.locationResults[0].lon),
			     }}
			     	onRightClick={this.handleRightClick}
				  >
				  <MarkerClusterer averageCenter 
				  enableRetinaIcons={true} gridSize={30}
				  >
				    {this.state.locationResults.map((item, index) => (
				      <Marker
				        position={{
				        	lat: parseFloat(item.lat),
				        	lng: parseFloat(item.lon),
				        }}
				        key={index}
				        label={item.name}
				        defaultAnimation="2"
				        onClick={()=>{
						   this.setState({destinationIndex: index})
						   this.handleRightClick()
				        }}
				      />
				    ))}
				   </MarkerClusterer>
				   {(this.state.directions) ? <DirectionsRenderer directions={this.state.directions} /> : null }
				  </WrappedGoogleMap>


  			 </div>
  			</div>

             :
          null}
        </div>
         </Header>
      </div>
    )
  }

rowRenderer = ({ index, isScrolling, key, parent, style }) =>  {
  return (
    <CellMeasurer
      cache={cache}
      columnIndex={0}
      key={key}
      parent={parent}
      rowIndex={index}
    >
    <div style={style}>
	   <IndivList 
	   item={this.state.locationResults[index]} 
	   onClick={()=>{
	   	this.setState({ destinationIndex: index })
	   	this.handleRightClick()
	   }}
	   className={(this.state.destinationIndex == index) ? "movieitem selected" : " movieitem " }
	   />
    </div>
    </CellMeasurer>
  );
}  
}
class IndivList extends React.Component{
	constructor(props){
		super(props);
	}
	render(){
		const { item, ...other } = this.props;
		return(
		<div {...other}>
			<h4 className="item-header">{item.name}</h4>
			<div className="item-content">
				<p>{item.address}</p>
				<p>{`${item.city}, ${item.state} ${item.zip}`}</p>
				<p>{item.theaterChainName}</p>
			</div>
		</div>
		);
	}
}




const Craftletters = 
[      <svg  className="papercraft papercraft-a" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d=" M16 0 L32 32 L0 32 Z "/>
        <path className="papercraft-front" d=" M16 0 L20 24 L0 32 Z "/>
      </svg>,

      <svg  className="papercraft papercraft-b" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L16 0 L32 18 L26 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L26 0 L32 6 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-c" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L28 0 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L30 0 L32 8 Z M0 8 L32 32 L0 32 Z"/>
      </svg>,
      
      <svg  className="papercraft papercraft-d" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L16 0 L32 18 L28 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L22 26 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-e" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L16 0 L32 16 L24 24 L32 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 0 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-f" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L16 0 L32 16 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 0 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-g" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L28 0 L0 32 Z M0 32 L32 16 L32 32 Z"/>
        <path className="papercraft-front" d="M0 0 L30 0 L32 8 Z M0 8 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-h" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L6 0 L12 32 L0 32 Z M20 0 L32 0 L32 32 L22 32 Z"/>
        <path className="papercraft-front" d="M32 0 L32 20 L0 32 L0 12 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-i" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-front" d="M10 0 L22 0 L22 32 L10 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-j" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M20 0 L32 0 L32 32 L16 32 Z"/>
        <path className="papercraft-front" d="M0 24 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-k" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 0 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-l" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L14 0 L16 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 32 L4 20 L32 26 L32 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-m" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M32 0 L32 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-n" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M20 0 L32 0 L32 32 L16 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-o" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-front" d="M0 0 L32 0 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-p" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L16 0 L12 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 0 L30 20 L0 28 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-q papercraft-tall" width="64" height="80" viewBox="0 0 32 40">
        <path className="papercraft-back" d="M0 0 L32 0 L32 40 L0 24 Z"/>
        <path className="papercraft-front" d="M0 0 L32 0 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-r" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 16 L32 32 L0 32 Z"/>
        <path className="papercraft-front" d="M0 0 L32 0 L30 20 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-s" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 16 L32 32 L0 16 Z"/>
        <path className="papercraft-front" d="M0 0 L32 0 L32 8 L0 16 Z M0 24 L32 16 L32 32 L0 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-t" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 0 L32 10 L22 10 L22 32 L10 32 L10 10 L0 10 Z"/>
        <path className="papercraft-front" d="M32 0 L32 10 L10 32 L10 10 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-u" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L6 0 L16 32 L2 32 Z"/>
        <path className="papercraft-front" d="M24 0 L32 0 L30 32 L2 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-v" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 0 L16 32 Z"/>
        <path className="papercraft-front" d="M0 0 L20 10 L16 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-w papercraft-wide" width="80" height="64" viewBox="0 0 40 32">
        <path className="papercraft-back" d="M0 0 L40 0 L32 32 Z"/>
        <path className="papercraft-front" d="M0 0 L40 0 L8 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-x" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 0 L16 16 Z M0 32 L16 16 L32 32 Z"/>
        <path className="papercraft-front" d="M0 0 L16 0 L32 32 L16 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-y" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 0 L22 12 L22 32 L10 32 L10 16 Z"/>
        <path className="papercraft-front" d="M10 0 L32 0 L10 32 Z"/>
      </svg>,

      <svg  className="papercraft papercraft-z" width="64" height="64" viewBox="0 0 32 32">
        <path className="papercraft-back" d="M0 0 L32 0 L32 16 L0 8 Z M0 20 L32 24 L32 32 L0 32 Z"/>
        <path className="papercraft-front" d="M32 0 L32 16 L0 32 L0 16 Z"/>
      </svg>];

const PaperCraft = (props) => {
	const { text,...other } = props;
	let letters = [];		
	for(let i=0;i<text.length;i++){
		const o = text.charAt(i);
		const index = o.toLowerCase().charCodeAt(0) - 97;
		if(index >= 0 || index <= 25){
			letters.push(<span key={i}>{Craftletters[index]}</span>);
		}else{
			letters.push(o)
		}
	}
	return (<div {...other}>{letters}</div>);
}



const IndexPage = () => (
  <div>
  	<Demo />
  </div>
 );

/*GET http://mdudetm.com/moviepass/api/theaters/10009*/
/*
<script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAcVx8hCXnGs25IODK1LVhHzPeCeI02QJI&libraries=places"></script>
*/
/*
          <!--
          <script>
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

            ga('create', 'UA-104905989-1', 'auto');
            ga('send', 'pageview');

          </script>
          -->          
*/
export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js